module.exports = __webpack_public_path__ + "f596d1de615be7cfaa6a6ca915880e9c.png";